<template>
    <div class="spinner-wrapper" :class="{'center': center}">
        <div class="spinner"></div>
    </div>
</template>

<script>
export default {
  props: ["center"]
};
</script>


<style scoped>
.spinner-wrapper {
  width: 100%;
}

.spinner-wrapper.center {
  text-align: center;
}

.spinner {
  display: inline-block;
  /*
  border: 1px solid #f3f3f3;
  */
  border: 6px solid #f3f3f3;
  border-top: 6px solid #0074cd;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin linear 1.5s;
  animation-iteration-count: infinite;
  -webkit-animation: spin linear 1.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-transform-origin: 50% 50%;
  -moz-animation: spin linear 1.5s;
  -moz-animation-iteration-count: infinite;
  -moz-transform-origin: 50% 50%;
  -o-animation: spin linear 1.5s;
  -o-animation-iteration-count: infinite;
  -o-transform-origin: 50% 50%;
  -ms-animation: spin linear 1.5s;
  -ms-animation-iteration-count: infinite;
  -ms-transform-origin: 50% 50%;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(360deg);
  }
}

@-ms-keyframes spin {
  0% {
    -ms-transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(360deg);
  }
}
</style>

